export default {
  getWishlistProductCount(state) {
    if (Array.isArray(state.sections)) {
      return state.sections.reduce((count, section) => count + section.products.length, 0);
    }
    return state.products?.length || 0;
  },
  isInWishlist: (state, getters) => (product) => {
    if (Array.isArray(state.sections) || Array.isArray(state.products)) {
      return getters.isProductInWishlist(product.productId);
    }
    return !!product.inWishlist;
  },
  isProductInWishlist: (state) => (productId) => {
    if (Array.isArray(state.sections)) {
      return state.sections.some((section) =>
        section.products.some((product) => product.productId === productId)
      );
    }
    return (state.products || []).some((product) => product.productId === productId);
  },
};
